module.exports = __webpack_public_path__ + "img/bg.3e04af77.png";